import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { MatchCardHeader } from '../components/header';
import { MatchCardFooter } from '../components/footer';
import { MatchCardTeamRow } from './teamRow';

import { generateTBCCardText } from 'widgets/ladder-predictor-v2/js/utils/generate-tbc-card-text';

import { handleConcludedMatch } from 'widgets/ladder-predictor-v2/js/utils/generate-bracket';
import { setPredictionFinals } from 'common/store/modules/ladder-predictor/init';
import { CONFIG } from '../../constants';
import { selectCutoffs } from 'widgets/ladder-predictor-v2/js/selector/ladder';

export const MatchCardFinalUpcoming = ({
    match,
    finalsStage,
    index,
    matchesData,
    seasonId,
    competitionId
}) => {
    const [predictedMatch, setPredictedMatch] = useState(match);
    const [matchStatus, setMatchStatus] = useState('');
    const [venueName, setVenueName] = useState('');
    const [startTime, setStartTime] = useState('');
    const [homeTeamScore, setHomeTeamScore] = useState(0);
    const [awayTeamScore, setAwayTeamScore] = useState(0);

    const { secondCutOff } = useSelector(selectCutoffs);

    const cardText = generateTBCCardText(
        finalsStage,
        index,
        secondCutOff > 0 ? true : false
    );

    const dispatch = useDispatch();

    const handleWinnerSelect = (winnerId, loserId, dataMatch) => {
        dispatch(
            setPredictionFinals({
                i: match.id, // Match id
                r: match.round.roundNumber, // Round number
                w: winnerId, // Winning team
                l: loserId, // Losing team
                n: match.round.name, // Round name
                c: dataMatch.status === CONFIG.CONCLUDED // Is match concluded
            })
        );
    };

    useEffect(() => {
        if (
            match?.home?.team?.id !== predictedMatch?.home?.team?.id ||
            match?.away?.team?.id !== predictedMatch?.away?.team?.id
        ) {
            setPredictedMatch(match);
        }
    }, [match]);

    useEffect(() => {
        const matchData = matchesData?.find(
            (singleMatchData) =>
                (singleMatchData?.home?.team?.id ===
                    predictedMatch?.home?.team?.id ||
                    singleMatchData?.home?.team?.id ===
                        predictedMatch?.away?.team?.id) &&
                (singleMatchData?.away?.team?.id ===
                    predictedMatch?.away?.team?.id ||
                    singleMatchData?.away?.team?.id ===
                        predictedMatch?.home?.team?.id)
        );

        if (matchData) {
            setMatchStatus(matchData.status);
            setVenueName(matchData.venue.name);
            setStartTime(matchData.utcStartTime);

            if (matchData?.home?.score || matchData?.away?.score) {
                if (predictedMatch?.home?.team?.id === matchData.home.team.id) {
                    setHomeTeamScore(matchData?.home?.score?.totalScore);
                } else if (
                    predictedMatch.home.team.id === matchData.away.team.id
                ) {
                    setHomeTeamScore(matchData?.away?.score?.totalScore);
                }

                if (predictedMatch?.away?.team?.id === matchData.away.team.id) {
                    setAwayTeamScore(matchData?.away?.score?.totalScore);
                } else if (
                    predictedMatch.away.team.id === matchData.home.team.id
                ) {
                    setAwayTeamScore(matchData?.home?.score?.totalScore);
                }
            }
        }
    }, [predictedMatch, matchesData]);

    useEffect(() => {
        handleConcludedMatch(matchesData, predictedMatch, handleWinnerSelect);
    }, [matchesData, predictedMatch]);

    return (
        <div className="ladder-predictor-match-card">
            <MatchCardHeader
                showComplete={false}
                venueName={venueName}
                startDateTime={startTime}
                showDate={true}
            />
            <div className="ladder-predictor-match-card__teams">
                <MatchCardTeamRow
                    match={predictedMatch}
                    isHomeTeam={true}
                    matchStatus={matchStatus}
                    cardText={cardText?.topText}
                    score={homeTeamScore}
                    seasonId={seasonId}
                    competitionId={competitionId}
                    isSelectable={
                        !!(
                            predictedMatch?.home?.team &&
                            predictedMatch?.away?.team
                        )
                    }
                />
                <MatchCardTeamRow
                    match={predictedMatch}
                    isHomeTeam={false}
                    matchStatus={matchStatus}
                    cardText={cardText?.bottomText}
                    score={awayTeamScore}
                    seasonId={seasonId}
                    competitionId={competitionId}
                    isSelectable={
                        !!(
                            predictedMatch?.home?.team &&
                            predictedMatch?.away?.team
                        )
                    }
                />
            </div>
            <MatchCardFooter
                matchName={predictedMatch?.round.name}
                showComplete={
                    matchStatus ===
                    PULSE.app.common.CONSTANTS.MATCH_STATUS.CONCLUDED
                        ? true
                        : false
                }
            />
        </div>
    );
};

MatchCardFinalUpcoming.propTypes = {
    match: PropTypes.object.isRequired,
    finalsStage: PropTypes.oneOf([
        'wildcard',
        'qualifying',
        'semiFinal',
        'preliminary',
        'grandFinal'
    ]),
    index: PropTypes.number,
    matchesData: PropTypes.array.isRequired,
    seasonId: PropTypes.string,
    competitionId: PropTypes.string
};
